import React from "react";
import "./PeerReviewerEvaluationApprovalForm.scss"
import PeerReviewerEvaluationApprovalForm from "../../features/PeerReviewerEvaluationApprovalForm/PeerReviewerEvaluationApprovalForm";

const PeerReviewerEvaluationApproval = () => {
  return (
    <div className="page-container">
      <PeerReviewerEvaluationApprovalForm />
    </div>
  );
};
export default PeerReviewerEvaluationApproval;
